import { ControlIcons } from 'owa-control-icons';
import { isFeatureEnabled } from 'owa-feature-flags';
import { MailIcons } from 'owa-mail-icons';
import { getListViewNotificationDimensions } from 'owa-mail-list-dimensions';
import * as undoActions from 'owa-mail-undo';
import { lazyShowNotification, NotificationBarCallbackReason } from 'owa-notification-bar';
import { format } from 'owa-strings';
import strings from 'owa-strings/owa-mail-strings';
import folderStore from 'owa-folders';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import showNotificationOnDelete from '../../helpers/showNotificationOnDelete';
import { getUserConfiguration } from 'owa-session-store';

/**
 * show notification on move or archive
 * @param numberOfItems acted on for the action
 * @param destinationFolderId for the move action
 * @param allowUndo whether this scenario supports an undo
 */
export default function showNotificationOnMove(
    numberOfItems: number,
    destinationFolderId: string,
    allowUndo: boolean
) {
    if (
        !isFeatureEnabled('tri-notificationBar') ||
        !getUserConfiguration().UserOptions.ShowNotificationBar
    ) {
        return;
    }

    const destinationFolderName = folderStore.folderTable.get(destinationFolderId).DisplayName;
    const isArchive = folderIdToName(destinationFolderId) === 'archive';
    const isDelete = folderIdToName(destinationFolderId) === 'deleteditems';

    if (isDelete) {
        showNotificationOnDelete(numberOfItems, allowUndo);
        return;
    }

    let notificationText;

    if (isArchive) {
        notificationText =
            numberOfItems === 1
                ? strings.archiveItemSucceededNotification
                : format(strings.archiveItemsSucceededNotification, numberOfItems);
    } else {
        notificationText =
            numberOfItems === 1
                ? format(strings.moveItemSucceededNotification, destinationFolderName)
                : format(
                      strings.moveItemsSucceededNotification,
                      numberOfItems,
                      destinationFolderName
                  );
    }
    const notificationDimensions = getListViewNotificationDimensions();

    lazyShowNotification.importAndExecute('moveOrArchiveNotification', notificationText, {
        icon: isArchive ? ControlIcons.Archive : MailIcons.FabricMovetoFolder,
        primaryActionText: allowUndo ? strings.undoAction : null,
        // Want 12 px of padding on either side of the notificaiton bar
        minWidth: notificationDimensions.minWidth,
        maxWidth: notificationDimensions.maxWidth,
        notificationCallback: reason => {
            if (reason === NotificationBarCallbackReason.PrimaryActionClicked) {
                undoActions.lazyUndo.importAndExecute('NotificationBar');
            }
        },
    });
}
